/**
 * File types OCR can scope, as an `accept` attribute value.
 */
export const ACCEPTED_OCR_FILE_TYPES =
  '.jpeg, .jpg, .png, .bmp, .webp, .pdf, .tiff, .tif'
